import MenuIcon from "@mui/icons-material/Menu";
import { FC, MouseEvent, useContext, useEffect, useState } from "react";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";

import useAuthStore from "../../../states/zustand/authStore";
import * as authService from "./../../../services/auth";

import IMAGES from "../../../constants/images";
import { RoutingList } from "../../../constants";
import { SidebarWidthMenu } from "../../../helpers/context/SidebarWidthMenu";
import { useResponsive } from "../../../helpers/customHooks/useResponsive";
import styles from "./Navbar.module.scss";
import { useNavigate } from "react-router-dom";
import { GetUserByIdQuery, useGetUserByIdLazyQuery } from "../../../generated/graphql";

interface INavbar {
  pageTitle: string;
  data?: GetUserByIdQuery | undefined;
}

const Navbar: FC<INavbar> = (props): JSX.Element => {
  const { pageTitle } = props;
  const [isMobile] = useResponsive();
  const {
    profileData: { _id },
    setProfileData,
  } = useAuthStore();
  const [getUserData, { data, loading }] = useGetUserByIdLazyQuery();
  const [openProfile, setOpenProfile] = useState<null | HTMLElement>(null);
  const { toggleMenu, setToggleMenu } = useContext(SidebarWidthMenu);
  const { setProfileDataEmpty, profileData } = useAuthStore((state) => state);
  const navigate = useNavigate();
  const logoutHandler = () => {
    setProfileDataEmpty();
    authService.logout();
  };

  const profileHandler = () => {
    navigate(RoutingList.profile.index.path);
  };

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setOpenProfile(event.currentTarget);
  };
  const menus = [
    {
      label: "Profile",
      route: RoutingList.profile.index.path,
      onClickHandler: profileHandler,
    },
    {
      label: "Logout",
      route: RoutingList.index.path,
      onClickHandler: logoutHandler,
    },
  ];
  const handleCloseUserMenu =
    (selectedMenu: { label: string; route: string }) => () => {
      setOpenProfile(null);
    };

    useEffect(() => {
      const getUser = async () => {
        await getUserData({
          variables: {
            id: _id,
          },
        });
      };
      getUser();
    }, [_id, getUserData]);

  return (
    <>
      <AppBar
        position="static"
        className={`${styles.appBar} ${styles.navBar}`}
        elevation={0}
      >
        <Container maxWidth={false}>
          <Toolbar
            className={`d-flex align-items-center justify-content-between ${styles.toolbar}`}
            disableGutters
          >
            <Box className="d-flex align-items-center">
              {isMobile && (
                <IconButton
                  size="large"
                  edge="start"
                  color="default"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                  onClick={() => setToggleMenu(!toggleMenu)}
                >
                  <MenuIcon />
                </IconButton>
              )}
              <Typography variant="h1" component="h1">
                {pageTitle}
              </Typography>
            </Box>

            <Box className="d-flex align-items-center">
              <Typography
                className={`${styles.name} mg-r-16`}
                variant="h6"
                noWrap
                component="p"
              >
                {/* {profileData.name} */}
                {data?.getUserById.name}
              </Typography>
              <Tooltip title="">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  {/* <Avatar alt="profile" src={profileData.avatar} /> */}
                  <Avatar
                    alt={data?.getUserById.name || 'profile'}
                    src={data?.getUserById.avatar || IMAGES.Profile}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                className={styles.menu}
                id="menu-appbar"
                anchorEl={openProfile}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(openProfile)}
                onClose={handleCloseUserMenu({ label: "", route: "" })}
              >
                {menus.map((menu) => (
                  <MenuItem key={menu?.label}>
                    <Typography
                      textAlign="center"
                      onClick={() => {
                        menu.onClickHandler?.();
                      }}
                    >
                      {menu?.label}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Navbar;
